import { createGenericListItemReducer } from "common/genericListItemReducer";
import {
  PRODUCT_UPLOAD_INFO_RECEIVED,
  PRODUCT_UPLOAD_INFO_REQUESTED,
  PRODUCT_UPLOAD_INFO_REQUEST_FAILED
} from "./storageActions";

export const storage = createGenericListItemReducer(
  PRODUCT_UPLOAD_INFO_REQUESTED,
  PRODUCT_UPLOAD_INFO_RECEIVED,
  PRODUCT_UPLOAD_INFO_REQUEST_FAILED
);
